// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
  }
  
  .hero-section-main-black-container {
    width: 100%;
    background-color: #212529;
    overflow: hidden;
  }
  
  /* Navbar */
  .hero-section-navbar-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 5%;
    color: white;
    background-color: #212529;
    margin-left: 120px;
    margin-right: 120px;
  }

  .hero-section-navbar-flex-row-style {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .hero-section-logo-image-style {
    height: 60px;
    width: 60px;
    margin-right: 16px;
  }

  
  .nav-links {
    display: flex;
    list-style: none;
  }
  
  .nav-links li {
    margin: 0 15px;
  }
  
  .nav-links a {
    text-decoration: none;
    color: white;
  }
  
  .contact-btn {
    background-color: white;
    color: black;
    border: none;
    padding: 8px 15px;
    cursor: pointer;
    border-radius: 5px;
    padding-left: 33px;
    padding-right: 33px;
  }
  
  /* Hero Section */
  .hero {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 50px 0%;
    background-color: #212529;
    color: white;
  }

  .hero-section-bold-text-parent-container {
    display: flex;
    justify-content: flex-start; /* Aligns content to the left */
  }

  .hero-section-bold-text-style {
    font-size: 48px;
    font-weight: 700;
    color: #ffff;
    text-align: left;
    align-self: flex-start; /* Works inside a flex container */
    font-family: "Plus Jakarta Sans", serif;
  }

  .hero-section-medium-text-style {
    font-size: 18px;
    font-weight: 500;
    color: #ffff;
    text-align: left;
    align-self: flex-start; /* Works inside a flex container */
    font-family: "Plus Jakarta Sans", serif;
    margin-top: 20px;
  }
  
  .hero-section-hero-content {
    width: 50%;
    height: 40vh;
    max-width: 500px;
    margin-left: 140px;
  }
  

  
  .hero-section-buttons-container {
    margin-top: 42px;
    display: flex;
    justify-content: flex-start;
  }

  .hero-section-nav-link-text {
    font-size: 18px;
    font-weight: 700;
    color: #ffff;
    font-family: "Plus Jakarta Sans", serif;

  }
  
  .btn {
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    margin-right: 10px;
    border-radius: 10px;
    padding-left: 33px;
    padding-right: 33px;
  }
  
  .primary {
    background-color: white;
    color: black;
    padding-left: 33px;
    padding-right: 33px;
    transition: transform 0.3s ease-in-out;
  }

  .primary:hover {
    background-color: #28a745;
  }

  .btn-text {
    font-size: 16px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
  }


  .hero-image-container {
    width: 44%;
    height: 450px;
    position: relative;
    display: inline-block;
}

.hero-image {
    width: 100%;
    height: 500px;
    border-top-left-radius: 40px;
    display: block;
    position: relative; /* Ensure it's above the pseudo-element */
    z-index: 2; /* Make sure the image is above the orange shape */
}

.hero-section-header-style {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #212529;
  z-index: 9999;
}

.hero-section-main-black-container {
  width: 100%;
  background-color: #212529;
  overflow: hidden;
  padding-top: 80px; /* Adjust based on navbar height */
}

.hero-section-navbar-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 5%;
  color: white;
  background-color: #212529;
}

/* Orange shape */
.hero-image-container::before {
    content: "";
    position: absolute;
    left: -30px;
    bottom: -90px;
    width: 369px;
    height: 204px;
    background-color: orange;
    border-bottom-right-radius: 60px;
    z-index: 2; /* Ensure it's behind the image */
}

  /* Responsive Design */
  @media (max-width: 768px) {
    .hero-section-navbar-section {
      flex-direction: column;
    }
  
    .nav-links {
      margin-top: 10px;
      flex-direction: column;
    }
  
    .nav-links li {
      margin: 5px 0;
    }
  
    .hero {
      flex-direction: column;
      text-align: center;
    }
  
    .hero-image img {
      margin-top: 20px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Home/Component/Hero/heroSection.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;;EAGA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,2BAA2B,EAAE,+BAA+B;EAC9D;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB,EAAE,kCAAkC;IAC1D,uCAAuC;EACzC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB,EAAE,kCAAkC;IAC1D,uCAAuC;IACvC,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;;;EAIA;IACE,gBAAgB;IAChB,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uCAAuC;;EAEzC;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;EACzC;;;EAGA;IACE,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,cAAc;IACd,kBAAkB,EAAE,yCAAyC;IAC7D,UAAU,EAAE,kDAAkD;AAClE;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB,EAAE,kCAAkC;AACvD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,gCAAgC;IAChC,UAAU,EAAE,iCAAiC;AACjD;;EAEE,sBAAsB;EACtB;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;MACtB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;EACF","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: Arial, sans-serif;\n  }\n  \n  .hero-section-main-black-container {\n    width: 100%;\n    background-color: #212529;\n    overflow: hidden;\n  }\n  \n  /* Navbar */\n  .hero-section-navbar-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 5%;\n    color: white;\n    background-color: #212529;\n    margin-left: 120px;\n    margin-right: 120px;\n  }\n\n  .hero-section-navbar-flex-row-style {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .hero-section-logo-image-style {\n    height: 60px;\n    width: 60px;\n    margin-right: 16px;\n  }\n\n  \n  .nav-links {\n    display: flex;\n    list-style: none;\n  }\n  \n  .nav-links li {\n    margin: 0 15px;\n  }\n  \n  .nav-links a {\n    text-decoration: none;\n    color: white;\n  }\n  \n  .contact-btn {\n    background-color: white;\n    color: black;\n    border: none;\n    padding: 8px 15px;\n    cursor: pointer;\n    border-radius: 5px;\n    padding-left: 33px;\n    padding-right: 33px;\n  }\n  \n  /* Hero Section */\n  .hero {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 50px 0%;\n    background-color: #212529;\n    color: white;\n  }\n\n  .hero-section-bold-text-parent-container {\n    display: flex;\n    justify-content: flex-start; /* Aligns content to the left */\n  }\n\n  .hero-section-bold-text-style {\n    font-size: 48px;\n    font-weight: 700;\n    color: #ffff;\n    text-align: left;\n    align-self: flex-start; /* Works inside a flex container */\n    font-family: \"Plus Jakarta Sans\", serif;\n  }\n\n  .hero-section-medium-text-style {\n    font-size: 18px;\n    font-weight: 500;\n    color: #ffff;\n    text-align: left;\n    align-self: flex-start; /* Works inside a flex container */\n    font-family: \"Plus Jakarta Sans\", serif;\n    margin-top: 20px;\n  }\n  \n  .hero-section-hero-content {\n    width: 50%;\n    height: 40vh;\n    max-width: 500px;\n    margin-left: 140px;\n  }\n  \n\n  \n  .hero-section-buttons-container {\n    margin-top: 42px;\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  .hero-section-nav-link-text {\n    font-size: 18px;\n    font-weight: 700;\n    color: #ffff;\n    font-family: \"Plus Jakarta Sans\", serif;\n\n  }\n  \n  .btn {\n    padding: 10px 20px;\n    border: none;\n    cursor: pointer;\n    margin-right: 10px;\n    border-radius: 10px;\n    padding-left: 33px;\n    padding-right: 33px;\n  }\n  \n  .primary {\n    background-color: white;\n    color: black;\n    padding-left: 33px;\n    padding-right: 33px;\n    transition: transform 0.3s ease-in-out;\n  }\n\n  .primary:hover {\n    background-color: #28a745;\n  }\n\n  .btn-text {\n    font-size: 16px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n  }\n\n\n  .hero-image-container {\n    width: 44%;\n    height: 450px;\n    position: relative;\n    display: inline-block;\n}\n\n.hero-image {\n    width: 100%;\n    height: 500px;\n    border-top-left-radius: 40px;\n    display: block;\n    position: relative; /* Ensure it's above the pseudo-element */\n    z-index: 2; /* Make sure the image is above the orange shape */\n}\n\n.hero-section-header-style {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  background-color: #212529;\n  z-index: 9999;\n}\n\n.hero-section-main-black-container {\n  width: 100%;\n  background-color: #212529;\n  overflow: hidden;\n  padding-top: 80px; /* Adjust based on navbar height */\n}\n\n.hero-section-navbar-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 5%;\n  color: white;\n  background-color: #212529;\n}\n\n/* Orange shape */\n.hero-image-container::before {\n    content: \"\";\n    position: absolute;\n    left: -30px;\n    bottom: -90px;\n    width: 369px;\n    height: 204px;\n    background-color: orange;\n    border-bottom-right-radius: 60px;\n    z-index: 2; /* Ensure it's behind the image */\n}\n\n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .hero-section-navbar-section {\n      flex-direction: column;\n    }\n  \n    .nav-links {\n      margin-top: 10px;\n      flex-direction: column;\n    }\n  \n    .nav-links li {\n      margin: 5px 0;\n    }\n  \n    .hero {\n      flex-direction: column;\n      text-align: center;\n    }\n  \n    .hero-image img {\n      margin-top: 20px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
